<template>
  <Fragment>
    <template v-if="$route.name !== 'materialIndex'">
      <router-view></router-view>
    </template>
    <section class="container" v-else>
      <Breadcrumb />
      <div class="card-wrap mt-20 mb-20">
        <section class="card-content">
          <div class="left">
            <div class="search-name mr-15">
              <span>物料编码：</span>
              <el-input v-model="materialCode"> </el-input>
            </div>
            <div class="search-name mr-15">
              <span>物料型号：</span>
              <el-input v-model="materialDesc"> </el-input>
            </div>
            <el-button
              type="primary"
              class="ml-20"
              @click="searchBaseDataMaterialInfo"
              >查询</el-button
            >
          </div>
          <el-button type="primary" class="mr-20" @click="addMaterial"
            >添加物料</el-button
          >
        </section>
      </div>
      <el-table :data="list" style="width: 100%" border>
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            <span>{{ scope.$index + (pageNum - 1) * pageSize + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="物料编码" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.materialCode }}</span>
          </template>
        </el-table-column>
        <el-table-column label="物料型号" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.materialDesc }}</span>
          </template>
        </el-table-column>
        <el-table-column label="跳转地址" width="450">
          <template slot-scope="scope">
            <span>{{ scope.row.materialUrl }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" :fit="true">
          <template slot-scope="scope">
            <el-button size="mini" @click="editMaterialInfo(scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="deleteMaterial(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20 pagination"
        background
        layout="total,prev, pager, next, jumper"
        :total="total"
        :page-size="10"
        :current-page="pageNum"
        @prev-click="handlePrePage"
        @next-click="handleNextPage"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </section>
  </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";

import Breadcrumb from "@/components/Breadcrumb";
export default {
  name: "role",
  components: {
    Breadcrumb,
    Fragment
  },
  data() {
    return {
      materialCode: "",
      materialDesc: "",
      list: [],
      pageNum: 1,
      pageSize: 10,
      total: 0
    };
  },
  methods: {
    getBaseDataMaterialList() {
      let _this = this;
      let param = {
        url: "/api/material/getMaterialLandingPage",
        params: {
          materialCode: _this.materialCode,
          materialDesc: _this.materialDesc,
          pageNum: _this.pageNum,
          pageSize: _this.pageSize
        }
      };

      _this.$store.dispatch("getBaseDataMaterialList", param).then(() => {
        _this.list = _this.$store.state.material.baseDataMaterialList.list;
        _this.total = _this.$store.state.material.baseDataMaterialList.total;
      });
    },
    //查询
    searchBaseDataMaterialInfo() {
      let _this = this;
      _this.getBaseDataMaterialList();
    },
    //当前页
    handleCurrentChange(value) {
      let _this = this;
      _this.pageNum = value;
      _this.getBaseDataMaterialList();
    },
    //上一页
    handlePrePage() {
      let _this = this;
      _this.pageNum -= 1;
      _this.getBaseDataMaterialList();
    },
    //下一页
    handleNextPage() {
      let _this = this;
      _this.pageNum += 1;
      _this.getBaseDataMaterialList();
    },
    //编辑
    editMaterialInfo(row) {
      this.$router.push({
        name: "editMaterialInfo",
        params: { materialId: row.materialId }
      });
    },
    //删除
    deleteMaterial: function(row) {
      let _this = this;
      if (confirm("确定要删除吗") === true) {
        let param = {
          url: "/api/material/deleteMaterialInfoById",
          params: { materialId: row.materialId }
        };

        _this.$Api
          .get(param.url, param.params)
          .then(response => {
            if (response.status === 200) {
              _this.getBaseDataMaterialList();
              _this.$message({
                message: "物料着陆页信息删除成功",
                type: "success"
              });
              this.$router.push({
                name: "materialIndex"
              });
            } else {
              _this.$message({
                message: response.data.msg,
                type: "error"
              });
            }
          })
          .catch(err => {});
      }
    },
    //添加
    addMaterial() {
      this.$router.push({
        name: "addMaterialInfo"
      });
    }
  },
  created() {
    let _this = this;
    _this.getBaseDataMaterialList();
  }
};
</script>

<style lang="sass" scoped>
.card-wrap
  .card-content
    display: flex
    align-items: center
    justify-content: space-between
    .left
      display: flex
    .el-button
      font-size: 14px
    .search-name, .search-code
      font-size: 14px
      display: flex
      align-items: center
      span
        white-space: nowrap
.pagination
  text-align: center
</style>
